import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';
import 'antd/dist/antd.css';

import { Select, Card, Drawer, Input, Row, Col, Tabs, Upload, message, Button, Checkbox } from 'antd';
import { GetEmpresaEnAPI, SetEmpresaEnAPI, CargaMasivaClientesEnAPI } from "../action/actionCreatorsRequests";

import { MSGERROR, MSGOK, traducirPagina, obtenerUsuario } from "../librerias/funciones"
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
    InboxOutlined,
    UploadOutlined,
    ClearOutlined,
    CloudUploadOutlined
} from '@ant-design/icons';
import store from '../store'
const { Dragger } = Upload;
const { Option } = Select;
const { TabPane } = Tabs;

const FichaMasiva = ({ props, configApp, openDrawerEmpresa, }) => {
    const [idiomas, setIdiomas] = React.useState({});
    const [hayEmpresa, setHayEmpresa] = React.useState(false);
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [imagenPrevia, setImagenPrevia] = React.useState({ original: "", modificado: "", tipoLogotipo: "" });
    const [fileList, setFileList] = React.useState([]);

    const [limpiarLista, setLimpiarLista] = React.useState(false);
    const [bloquearPantalla, setBloquearPantalla] = React.useState(false);
    const [socioPorDefecto, setSocioPorDefecto] = React.useState({});

    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: null,
            ID_USUARIO_SERTEC: 0,
            ID_TALLER: 0,
            RAZON: "",
            CIF: "",
            DIRECCION: "",
            POBLACION: "",
            PROVINCIA: "",
            CP: "",
            PAIS: "",
            TELEFONO: "",
            TELEFONO_2: "",
            TELEFONO_3: "",
            MAIL: "",
            OBSERVACIONES: "",
            EMAIL: "",
            PRECIO_MANO_OBRA: "",
            CIENTO_IVA: "",
            LOGOTIPO: "",
            COMENTARIOS_PIE_PRESUPUESTO: "",
            REGISTRO_MERCANTIL: "",
        }
    )

    if (!hayEmpresa && props.ABRIR_FICHA) {
        setHayEmpresa(true);
        let accesoLicencia = obtenerUsuario();
        let obtenerSocio = accesoLicencia.SOCIOS.find(socio => socio.ID_SOCIO === props.ID_SOCIO)
        if (obtenerSocio !== undefined) {
            setSocioPorDefecto(obtenerSocio);
        }
    } else {
        if (!props.ABRIR_FICHA && hayEmpresa) {
            setLimpiarLista(false)
            setSocioPorDefecto({})
            setHayEmpresa(false);
            setTabPorDefecto("1");
            setImagenPrevia({ original: "", modificado: "", tipoLogotipo: "" })
            setFileList([])
            setPayLoadLocal({
                ID: null,
                ID_USUARIO_SERTEC: 0,
                ID_TALLER: 0,
                RAZON: "",
                CIF: "",
                DIRECCION: "",
                POBLACION: "",
                PROVINCIA: "",
                CP: "",
                PAIS: "",
                TELEFONO: "",
                TELEFONO_2: "",
                TELEFONO_3: "",
                MAIL: "",
                OBSERVACIONES: "",
                EMAIL: "",
                PRECIO_MANO_OBRA: "",
                CIENTO_IVA: "",
                LOGOTIPO: "",
                COMENTARIOS_PIE_PRESUPUESTO: "",
                REGISTRO_MERCANTIL: "",
            })
        }
    }



    const modificarUsuario = () => {
        if(imagenPrevia.tipoLogotipo !== ""){
            MSGOK("Se esta subiendo el fichero, esto puede tardar un poco.");

            setBloquearPantalla(true);
    
            CargaMasivaClientesEnAPI(socioPorDefecto.ID_SOCIO, imagenPrevia.modificado, limpiarLista).then(usuario => {
                setBloquearPantalla(false);
                if (usuario.OK) {
                    MSGOK("CSV subido correctamente.")
                    props.ACTUALIZAR_MASIVA(false);

                    if(props.ACTUALIZAR_CLIENTES === null){
                        props.ACTUALIZAR_SECUNDARIO()
                    }else{
                        props.ACTUALIZAR_CLIENTES(0, 1, "A", socioPorDefecto.ID_SOCIO);
                    }
    
                }
            })
        }else{
            MSGERROR("Seleccione el fichero");
        }

    }

   


    const componente = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList)

            if (newFileList.length === 0) {
                setImagenPrevia({ original: "", modificado: "", tipoLogotipo: "" })
            }
        },
        beforeUpload: file => {


            if (file.type === 'text/csv' || file.type === "application/vnd.ms-excel") {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    let texto = "data:" + file.type + ";base64,"
                    let cadena = reader.result.replace(texto, "")
                    setImagenPrevia({ original: reader.result, modificado: cadena, tipoLogotipo: file.type })
                };
                reader.onerror = function (error) {
                    MSGERROR("Problemas al cargar el fichero: ", error)
                };

                let fichero = fileList
                fichero.push(file)
                setFileList(fichero)
            }  else {
                MSGERROR(`${file.name} no tiene extensión .csv`)
               
            }
            return file.type === 'text/csv' || file.type === "application/vnd.ms-excel" ? false : Upload.LIST_IGNORE;
        }
    };

    return (
        <Drawer
            width={600}
            onClose={() => {props.ACTUALIZAR_MASIVA(bloquearPantalla ? true: false) }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '99999999', color: '#fff' }}>
            <div className="flex-container-Grow-Tercero" >
                <div style={{ textAlign: 'inherit' }}>
                    <MDBBtn disabled={bloquearPantalla} className="backgrounNegroClaro soloColorBlanco" aria-label="Close" style={{ border: 'none', width: '61px', height: '61px', padding: '0px', margin: '0px', borderRadius: 'unset' }} onClick={(e) => { props.ACTUALIZAR_MASIVA(false);  }} >
                        <i aria-label="icon: close" className="anticon anticon-close">
                            <svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" style={{ fontSize: '16px' }} ><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                            </svg>
                        </i>
                    </MDBBtn>
                </div>

                <div style={{ width: '500px', color: '#fff', verticalAlign: 'middle', paddingLeft: '10px', fontSize: '16px' }}>
                    {props.title}
                </div>
            </div>

            {payLoadLocal === null ?
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h4>{"No se pudo establecer conexión con el servidor"}</h4>
                </div>
                :
                <div>
                    <div style={{ height: (configApp.height - 170).toString() + "px", }} className="mb-2" >
                        <div style={{ height: (configApp.height - 170).toString() + "px", }} className="ml-4 mr-4 mt-4">
                            <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>

                                <Col md={24}>
                                    {traducirPagina("Info_importacion_socio") + socioPorDefecto.NOMBRE_SOCIO}
                                    <br></br>
                                    <br></br>
                                    {traducirPagina("Msg_importacion_csv") }
                                    <br></br>
                                    <br></br>
                                    

                                    <u style={{fontWeight:'bold'}}>{traducirPagina("Msg_importacion_cabecera_1")}</u>{`${traducirPagina("Msg_importacion_cabecera_2")}: `}
                                    <br></br>
                                   
                                    <ul>
                                        <li>{traducirPagina("Codigo")}</li>
                                        <li>{traducirPagina("Nombre")}</li>
                                        <li>{traducirPagina("Cif_masiva")}</li>
                                        <li>{traducirPagina("Direccion")}</li>
                                        <li>{traducirPagina("Poblacion")}</li>
                                        <li>{traducirPagina("Provincia")}</li>
                                        <li>{traducirPagina("Cp_masiva")}</li>
                                        <li>{traducirPagina("Telefono")}</li>
                                        <li>{traducirPagina("Mail_masiva")}</li>
                                    </ul>
                                </Col>


                                <Col md={24}>
                                    <Checkbox checked={limpiarLista} onChange={(e) => { setLimpiarLista(e.target.checked) }} >{traducirPagina("Info_inportacion")}</Checkbox>
                                </Col>


                                <Col md={12}>
                                    <Upload {...componente}
                                        maxCount={1}
                                    >
                                        <Button style={{ display: imagenPrevia.tipoLogotipo !== "" ? 'none' : '' }} ><UploadOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Seleccione_fichero")}</Button>
                                    </Upload>
                                </Col>

                                <Col md={12}>
                                    <Button style={{ display: imagenPrevia.tipoLogotipo === "" ? 'none' : '' }} onClick={(e) => setImagenPrevia({ original: "", modificado: "", tipoLogotipo: "" })}> <DeleteOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Limpiar_fichero")}</Button>
                                </Col>
                              
                            </Row>
                        </div>
                    </div>

                    <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4" >
                        <button disabled={bloquearPantalla} className="activebtnMenu2" style={{ height: '40px', width: '220px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color:!bloquearPantalla ? '#000':'#ddd', cursor: 'pointer' }} onClick={(e) => modificarUsuario()}><CloudUploadOutlined  style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Importar").toUpperCase()} </span>  </button>
                    </div>

                </div>
            }
        </Drawer>
    )
}
FichaMasiva.propTypes = {
    onClick: PropTypes.func,
    ACTUALIZAR_CLIENTES: PropTypes.func,
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    ACTUALIZAR_MASIVA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ACTUALIZAR_SECUNDARIO: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,
        openDrawerEmpresa: state.estadoDrawer.openDrawerEmpresa,

    };
}

export default connect(mapStateToProps)(FichaMasiva);